import {
  calculateShowFigures,
} from "@quantizr-engineering/common/math/live";
import { ShowStatus } from "@quantizr-engineering/common/types/show";
import { ShowData } from "../Show";
import { Team } from "@quantizr-engineering/common/types/team";

export interface CommissionRow {
  id: string;
  name: string;
  performanceDate: string;
  team: string;
  venue: string;
  city: string;
  state: string;
  walkout: number;
  commissionPercent: number;
  commissionAmount: number;
  commissionBuyout: number;
  flatFee: number;
  status: string;
}

export class MgrCommissionDataRowAdapter {
  toContracts(shows: ShowData[], teams: Team[] | null): CommissionRow[] {
    const flattenedRows: CommissionRow[] = [];

    // Filter for settled or paid shows
    const settledOrPaidShows = shows.filter(
      (show) =>
        show.status === ShowStatus.PAID || show.status === ShowStatus.SETTLED
    );

    settledOrPaidShows.forEach((show) => {
      if (show.commissions && show.commissions.length > 0) {
        const { commissionsActual } = calculateShowFigures(show as any);
        const { walkout } = calculateShowFigures(show as any);

        const team = teams?.find((t) => t.id === show.teamID);

        commissionsActual.commissions.forEach((commission) => {
          const name = commission.name || "Unnamed";

          flattenedRows.push({
            id: String(show.id),
            name: name,
            performanceDate: show.performanceDate.toISOString().split("T")[0], // Format as YYYY-MM-DD
            team: team ? team.name : "",
            venue: show.venue || "",
            city: show.city || "",
            state: show.state || "",
            walkout: walkout || 0,
            commissionPercent: commission.percent
              ? Math.round(commission.percent * 100) / 100
              : 0,
            commissionAmount: commission.amount,
            commissionBuyout: commission.commissionBuyout || 0,
            flatFee: commission.flatFee || 0,
            status: show.status || "",
          });
        });
      }
    });

    return flattenedRows;
  }
}
